import type { ButtonHTMLAttributes, ReactNode } from "react";
import { btnDanger, btnPrimary, btnSecondary } from "./classes";

export type ButtonVariant = "primary" | "secondary" | "danger";

const VARIANT: Record<ButtonVariant, string> = { primary: btnPrimary, secondary: btnSecondary, danger: btnDanger };

/** A real <button> with a type, a 44 px target, and a visible name — never an icon alone. */
export function Button({ variant = "secondary", className = "", type = "button", children, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant; children: ReactNode }) {
  return (
    <button type={type} className={`${VARIANT[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}
